<div class="card" style="width: 90vw; max-height: 80vh; overflow: auto;">
    <div class="card-subheader">
        <div class="title">{{ title }}</div>
    </div>
    <div class="card-body">
        <nb-alert [status]="alertStatus" class="d-flex flex-row align-items-center" *ngIf="isShowAlert">
            <nb-icon [icon]="alertIcon" class="flex-shrink-0"></nb-icon>
            <div class="px-2">{{ alertMessage }}</div>
        </nb-alert>

        <p>{{ content }}</p>
        <textarea [(ngModel)]="inputValue" name="input" *ngIf="withInput" type="text" nbInput fullWidth id="extrainput"
            placeholder="{{ inputPlaceholder }}"></textarea>
    </div>
    <div class="card-footer">
        <button nbButton size="small" (click)="cancel()" class="mx-2">{{ cancelButton }}</button>
        <button nbButton size="small" status="success" (click)="confirm()" class="mx-2">{{ confirmButton }}</button>
    </div>
</div>